import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isNumber,
  isSingleSelect,
} from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import PageLoader from "../../Helpers/PageLoader";

var dayList = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

var module = "timeSlot";
var moduleName = "Time Slot";
var modulePath = "/clientpanel/timeslot";
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = "";
    if (this.props.match.path === "/clientpanel/timeslot/edit/:EditID") {
      editID = this.props.match.params.EditID;
    }
    this.state = {
      editID: editID,
      pageloading: false,
      clientdata: {
        slotOutletID: "",
        slotAvailabilityID: "",
        slotType: "",
        timeslot: [
          {
            day: "",
            from: "",
            to: "",
            orderCount: "",
            orderCountType: "",
          },
        ],
        slotCuttOFFTime: "",
        slotInterval: "",
        slotMinimumDate: "",
        slotMaximumDate: "",
        datebasecount: [
          {
            date: "",
            from: "",
            to: "",
            orderCount: "",
          },
        ],
        slotStatus: "",
      },
      loading: true,
      tatList: [],
      availabiltyList: [],
      outlet_availability: [],
      formpost: [],
      companyDetail: [],
      outletList: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.loadOutlet();
    this.loadAvailabilty();

    if (this.state.editID !== "") {
      var params = {
        url: `${apiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          var history = this.props.history;
          setTimeout(function () {
            history.push(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var slotStatus = result.slotStatus === "A" ? "Active" : "In Active";
          var status =
            result.slotStatus !== "" &&
            result.slotStatus !== null
              ? {
                  label: slotStatus,
                  value: result.slotStatus,
                }
              : "";
          var slotType = "";
          if (result.slotType === 1) {
            slotType = { value: 1, label: "Time" };
          } else if (result.slotType === 2) {
            slotType = { value: 2, label: "Timeslot" };
          }
          let slotCuttOFFTime = '';
          if ( result.slotCuttOFFTime !== "" && result.slotCuttOFFTime !== null ) {
            slotCuttOFFTime = new Date(result.slotCuttOFFTime);
          }
          let timeslot = result?.slotTimeSettings ?? null;
          if(timeslot!==null) {
            timeslot = JSON.parse(timeslot);
          }
          let datebasecount = result?.slotTimeOrderCount ?? null;
          if(datebasecount!==null) {
            datebasecount = JSON.parse(datebasecount);
          }
          
          var clientupdatedata = {
            slotOutletID: result.slotOutletID,
            slotAvailabilityID: result.slotAvailabilityID,
            slotType: slotType,
            timeslot:(timeslot!==null)
                ? timeslot
                : [
                    {
                      day: "",
                      from: "",
                      to: "",
                      orderCount: "",
                      orderCountType: "",
                    },
                  ],
            datebasecount: datebasecount!==null
                ? datebasecount
                : [
                    {
                      date: "",
                      from: "",
                      to: "",
                      orderCount: "",
                    },
                  ],
            slotCuttOFFTime: slotCuttOFFTime,
            slotInterval: result.slotInterval,
            slotMinimumDate: result.slotMinimumDate,
            slotMaximumDate: result.slotMaximumDate,
            slotStatus: status,
          };
          console.log(clientupdatedata, "clientupdatedata");
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadOutlet() {
    var urlShringTxt =
      apiUrl + "outlet/dropDownList" ;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ outletList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  loadAvailabilty() {
    var urlShringTxt = apiUrl + "availability/companydropDownList";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ availabiltyList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }

  sateValChange = (field, value) => {
    if (field === "page") {
    }
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { clientdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
   // showLoader("submit_frm", "class");
    var postData = this.state.clientdata;
    var postObject = {
      slotOutletID: postData.slotOutletID?.value ?? '',
      slotAvailabilityID: postData.slotAvailabilityID?.value ?? "",
      slotType: postData.slotType?.value ?? "",
      slotTimeSettings: JSON.stringify(postData.timeslot),
      slotTimeOrderCount: JSON.stringify(postData.datebasecount),
      slotCuttOFFTime: postData.slotCuttOFFTime,
      slotInterval: postData.slotInterval,
      slotMinimumDate: postData.slotMinimumDate,
      slotMaximumDate: postData.slotMaximumDate,
      slotStatus:postData.slotStatus?.value ?? "A",
    };
    console.log(JSON.stringify(postData.timeslot), 'postData.timeslot')
    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"timeslot"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"}{" "}
                      {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.clientdata}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  categoryList={this.state.categoryList}
                  outletList={this.state.outletList}
                  availabiltyList={this.state.availabiltyList}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          100
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const {
    slotOutletID,
    slotAvailabilityID,
    slotType,
    slotMinimumDate,
    slotMaximumDate,
    slotStatus,
  } = props.fields;

  return {
    fields: [
      "slotOutletID",
      "slotAvailabilityID",
      "slotType",
      "slotMinimumDate",
      "slotMaximumDate",
      "slotStatus",
    ],

    validations: {
      slotOutletID: [[isSingleSelect, slotOutletID]],
      slotAvailabilityID: [[isSingleSelect, slotAvailabilityID]],
      slotType: [[isSingleSelect, slotType]],
      slotMinimumDate: [
        [isEmpty, slotMinimumDate],
        [isNumber, slotMinimumDate],
      ],
      slotMaximumDate: [
        [isEmpty, slotMaximumDate],
        [isNumber, slotMaximumDate],
      ],
      slotStatus: [[isSingleSelect, slotStatus]],
    },
  };
}

class PostForm extends Component {


  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  myFilter(elm) {
    return elm != null && elm !== false && elm !== "";
  }
  addSlot(e) {
    e.preventDefault();
    var timeslot = this.props.fields.timeslot;
    timeslot.push({
      day: "",
      from: "",
      to: "",
      order_count: "",
      order_count_type: "",
    });
    this.props.onChange("timeslot", timeslot);
  }
  removeSlot(removeIndex, e) {
    e.preventDefault();
    var timeslot = this.props.fields.timeslot;
    timeslot.splice(removeIndex, 1);
    this.props.onChange("timeslot", timeslot);
  }
  handleChangeCheckBox(slotIndex, name, event) {
    this.updateSlot(slotIndex, name, event.target.value, event.target.checked);
  }
  handleChangeCheckRadio(slotIndex, name, event) {
    this.updateSlot(slotIndex, name, event.target.value, "");
  }
  handleChangeAvailDate(slotIndex, name, selectDate) {
    console.log(selectDate, 'selectDateselectDate')
    this.updateSlot(slotIndex, name, selectDate, "");
  }

  handleChangeText(slotIndex, name, event) {
    this.updateSlot(slotIndex, name, event.target.value, "");
  }

  updateSlot(slotIndex, name, value, checkedStatus = null) {
    var timeslot = this.props.fields.timeslot;
    var updatedtimeslot = [];
    if (timeslot.length > 0) {
      timeslot.map((item, index) => {
        if (index === slotIndex) {
          var updday = item.day;
          var updfrom = item.from;
          var updto = item.to;
          var updorderCount = item.orderCount;
          var updorderCountType = item.orderCountType;

          if (name === "day") {
            var splitupdday = updday.split(",").filter(this.myFilter);
            if (checkedStatus === true) {
              splitupdday.push(value);
            } else {
              const index = splitupdday.indexOf(value);
              splitupdday.splice(index, 1);
            }
            updday = splitupdday.length > 0 ? splitupdday.join(",") : "";
          } else if (name === "fromtime") {
            updfrom = value;
          } else if (name === "totime") {
            updto = value;
          } else if (name === "orderCount") {
            updorderCount = value;
          } else if (name === "orderCountType") {
            updorderCountType = value;
          }

          updatedtimeslot.push({
            day: updday,
            from: updfrom,
            to: updto,
            orderCount: updorderCount,
            orderCountType: updorderCountType,
          });
        } else {
          updatedtimeslot.push(item);
        }
        return "";
      });
    }
    this.props.onChange("timeslot", updatedtimeslot);
  }
  handleChangeDate(name, selectDate) {
    this.props.onChange(name, selectDate);
  }
  addSpecificDate(e) {
    e.preventDefault();
    var datebasecount = this.props.fields.datebasecount;
    datebasecount.push({
      date: "",
      from: "",
      to: "",
      orderCount: "",
    });
    this.props.onChange("datebasecount", datebasecount);
  }
  handleChangeSpecificDate(slotIndex, name, selectDate) {
    this.updateDateSlot(slotIndex, name, selectDate);
  }
  handleChangeSpecificText(slotIndex, name, event) {
    this.updateDateSlot(slotIndex, name, event.target.value);
  }
  updateDateSlot(slotIndex, name, value) {
    var datebasecount = this.props.fields.datebasecount;
    var updateddatebasecount = [];
    if (datebasecount.length > 0) {
      datebasecount.map((item, index) => {
        if (index === slotIndex) {
          var upddate = item.date;
          var updfrom = item.from;
          var updto = item.to;
          var updorderCount = item.orderCount;

          if (name === "date") {
            upddate = value;
          } else if (name === "fromtime") {
            updfrom = value;
          } else if (name === "totime") {
            updto = value;
          } else if (name === "orderCount") {
            updorderCount = value;
          }

          updateddatebasecount.push({
            date: upddate,
            from: updfrom,
            to: updto,
            orderCount: updorderCount,
          });
        } else {
          updateddatebasecount.push(item);
        }
        return true
      });
    }
    this.props.onChange("datebasecount", updateddatebasecount);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgOutlet,
      errMsgAvail,
      errMsgSlotType,
      errMsgMin,
      errMsgMax,
      errMsgStatus = "";
    if ($validation.slotOutletID.error.reason !== undefined) {
      errMsgOutlet = $validation.slotOutletID.show && (
        <span className="error">{$validation.slotOutletID.error.reason}</span>
      );
    }
    if ($validation.slotAvailabilityID.error.reason !== undefined) {
      errMsgAvail = $validation.slotAvailabilityID.show && (
        <span className="error">
          {$validation.slotAvailabilityID.error.reason}
        </span>
      );
    }

    if ($validation.slotType.error.reason !== undefined) {
      errMsgSlotType = $validation.slotType.show && (
        <span className="error">{$validation.slotType.error.reason}</span>
      );
    }
    if ($validation.slotMinimumDate.error.reason !== undefined) {
      errMsgMin = $validation.slotMinimumDate.show && (
        <span className="error">{$validation.slotMinimumDate.error.reason}</span>
      );
    }
    if ($validation.slotMaximumDate.error.reason !== undefined) {
      errMsgMax = $validation.slotMaximumDate.show && (
        <span className="error">{$validation.slotMaximumDate.error.reason}</span>
      );
    }

    if ($validation.slotStatus.error.reason !== undefined) {
      errMsgStatus = $validation.slotStatus.show && (
        <span className="error">{$validation.slotStatus.error.reason}</span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3 mt-4">
          <div
            className={
              errMsgOutlet !== "" &&
              errMsgOutlet !== false &&
              errMsgOutlet !== undefined
                ? "col-md-6 error-select is-invalid error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box mb-4">
              <Select
                value={fields.slotOutletID}
                onChange={this.handleSelectChange.bind(this, "slotOutletID")}
                placeholder={"Select Outlet"}
                options={this.props.outletList}
              />
              <label className="select-box-label">
                Outlet<span className="error">*</span>
              </label>
              {errMsgOutlet}
            </div>
          </div>
          <div
            className={
              errMsgAvail !== "" &&
              errMsgAvail !== false &&
              errMsgAvail !== undefined
                ? "col-md-6 error-select is-invalid error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box mb-4">
              <Select
                value={fields.slotAvailabilityID}
                onChange={this.handleSelectChange.bind(
                  this,
                  "slotAvailabilityID"
                )}
                placeholder="Select Availabilty"
                options={this.props.availabiltyList}
              />
              <label className="select-box-label">
                Availabilty<span className="error">*</span>
              </label>
              {errMsgAvail}
            </div>
          </div>
          <div
            className={
              errMsgSlotType !== "" &&
              errMsgSlotType !== false &&
              errMsgSlotType !== undefined
                ? "col-md-6 error-select is-invalid error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box mb-4">
              <Select
                value={fields.slotType}
                onChange={this.handleSelectChange.bind(this, "slotType")}
                placeholder="Select Slot Type*"
                options={[
                  { label: "Time", value: 1 },
                  { label: "Timeslot", value: 2 },
                ]}
              />
              <label className="select-box-label">
                Slot Type<span className="error">*</span>
              </label>
              {errMsgSlotType}
            </div>
          </div>
          {fields.timeslot.length > 0 && (
            <>
              <div className="col-md-12 text-end mb-3">
                <a href="/" onClick={this.addSlot.bind(this)}>
                  <button
                    type="button"
                    className="btn btn-outline-primary waves-effect"
                  >
                    Add New
                  </button>
                </a>
              </div>

              <div className="col-md-12">
                {fields.timeslot.map((item, index) => {
                  return (
                    <div
                      className="card mb-4 border-2 border-primary mb-3"
                      key={index}
                    >
                      <div className="card-body">
                        <div className="text-end">
                          <a
                            href="/"
                            onClick={this.removeSlot.bind(this, index)}
                          >
                            <span className="mdi mdi-trash-can-outline"></span>
                          </a>
                        </div>
                        <h4 className="card-title">
                          Slot {parseInt(index) + 1}
                        </h4>
                        <div className="row g-3">
                          <div className="col-md-12">
                            <div className="form-group daywiseitem_form_group">
                              {dayList.map((day, dayListIndex) => {
                                var selectedday =
                                  item.day !== "" && item.day !== null
                                    ? item.day.split(",")
                                    : [];
                                return (
                                  <div
                                    className="form-check form-check-inline mt-3"
                                    key={dayListIndex}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={
                                        "day_" +
                                        index +
                                        "_" +
                                        dayListIndex +
                                        "_"
                                      }
                                      value={day.toLowerCase()}
                                      checked={
                                        selectedday.indexOf(
                                          day.toLowerCase()
                                        ) >= 0
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleChangeCheckBox.bind(
                                        this,
                                        index,
                                        "day"
                                      )}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={
                                        "day_" +
                                        index +
                                        "_" +
                                        dayListIndex +
                                        "_"
                                      }
                                    >
                                      {day}
                                    </label>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-floating-outline mt-2">
                              <DatePicker
                                className="form-control"
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={5}
                                timeCaption="Time"
                                dateFormat="h:mm aa"
                                placeholderText="From"
                                selected={
                                  item.from !== "" && item.from !== null
                                    ? new Date(item.from)
                                    : ""
                                }
                                onChange={this.handleChangeAvailDate.bind(
                                  this,
                                  index,
                                  "fromtime"
                                )}
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-floating-outline mt-2">
                              <DatePicker
                                className="form-control"
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={5}
                                timeCaption="Time"
                                dateFormat="h:mm aa"
                                placeholderText="To"
                                selected={
                                  item.to !== "" && item.to !== null
                                    ? new Date(item.to)
                                    : ""
                                }
                                onChange={this.handleChangeAvailDate.bind(
                                  this,
                                  index,
                                  "totime"
                                )}
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline mb-4 mt-2">
                              <input
                                type="text"
                                className="form-control"
                                name="sequence"
                                value={item.orderCount}
                                id="sequence"
                                onChange={this.handleChangeText.bind(
                                  this,
                                  index,
                                  "orderCount"
                                )}
                              />
                              <label htmlFor="sequence">Order Count</label>
                            </div>
                          </div>
                          {/* <div className="col-md-4">
                            <div className="form-check form-check-inline mt-3">
                              <input
                                className="form-check-input"
                                type="radio"
                                id={"ordercounttype_range" + index}
                                value="1"
                                checked={
                                  item.orderCountType === "1" ? true : false
                                }
                                onChange={this.handleChangeCheckRadio.bind(
                                  this,
                                  index,
                                  "orderCountType"
                                )}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={"ordercounttype_range" + index}
                              >
                                Between time range
                              </label>
                            </div>
                            <div className="form-check form-check-inline mt-3">
                              <input
                                className="form-check-input"
                                type="radio"
                                id={"ordercounttype_minutes" + index}
                                checked={
                                  item.orderCountType === "2" ? true : false
                                }
                                value="2"
                                onChange={this.handleChangeCheckRadio.bind(
                                  this,
                                  index,
                                  "orderCountType"
                                )}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={"ordercounttype_minutes" + index}
                              >
                                By Interval minutes
                              </label>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="col-md-12 text-end mb-3">
                <a href="/" onClick={this.addSlot.bind(this)}>
                  <button
                    type="button"
                    className="btn btn-outline-primary waves-effect"
                  >
                    Add New
                  </button>
                </a>
              </div>
            </>
          )}

          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgMin !== "" &&
                  errMsgMin !== false &&
                  errMsgMin !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="slotMinimumDate"
                value={fields.slotMinimumDate}
                id="slotMinimumDate"
                {...$field("slotMinimumDate", (e) =>
                  onChange("slotMinimumDate", e.target.value)
                )}
              />
              <label htmlFor="slotMinimumDate">
                Minimum Day<span className="error">*</span>
              </label>
              {errMsgMin}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgMax !== "" &&
                  errMsgMax !== false &&
                  errMsgMax !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="slotMaximumDate"
                value={fields.slotMaximumDate}
                id="slotMaximumDate"
                {...$field("slotMaximumDate", (e) =>
                  onChange("slotMaximumDate", e.target.value)
                )}
              />
              <label htmlFor="slotMaximumDate">
                Maximum Day<span className="error">*</span>
              </label>
              {errMsgMax}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating-outline mt-2">
              <DatePicker
                className="form-control"
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="h:mm aa"
                placeholderText="Cutof Time"
                selected={fields.slotCuttOFFTime}
                onChange={this.handleChangeDate.bind(this, "slotCuttOFFTime")}
              />
            </div>
          </div>
          {Object.keys(fields.slotType).length > 0 &&
            fields.slotType.value === 1 && (
              <div className="col-md-6">
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="slotInterval"
                    value={fields.slotInterval}
                    {...$field("slotInterval", (e) =>
                      onChange("slotInterval", e.target.value)
                    )}
                  />
                  <label htmlFor="slotInterval">
                    Interval Minutes<span className="error">*</span>
                  </label>
                </div>
              </div>
            )}

          {/* <hr />
          <h5 className="display-6 mb-0">Order count for a specific date</h5>
          <div className="col-md-12 text-end mb-3">
            <a href="/" onClick={this.addSpecificDate.bind(this)}>
              <button
                type="button"
                className="btn btn-outline-primary waves-effect"
              >
                Add New
              </button>
            </a>
          </div>
          {fields.datebasecount.length > 0 &&
            fields.datebasecount.map((item, index) => {
              return (
                <div
                  className="card mb-4 border-2 border-primary mb-3"
                  key={index}
                >
                  <div className="card-body">
                    <div className="text-end">
                      <a href="/">
                        <span className="mdi mdi-trash-can-outline"></span>
                      </a>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-floating-outline mt-2">
                          <DatePicker
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText="Date"
                            dateFormat="dd-MM-yyy"
                            minDate={new Date()}
                            selected={
                              item.date !== "" && item.date !== null
                                ? new Date(item.date)
                                : ""
                            }
                            onChange={this.handleChangeSpecificDate.bind(
                              this,
                              index,
                              "date"
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-floating-outline mt-2">
                          <DatePicker
                            className="form-control"
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                            placeholderText="From"
                            selected={
                              item.from !== "" && item.from !== null
                                ? new Date(item.from)
                                : ""
                            }
                            onChange={this.handleChangeSpecificDate.bind(
                              this,
                              index,
                              "fromtime"
                            )}
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="form-floating-outline mt-2">
                          <DatePicker
                            className="form-control"
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                            placeholderText="To"
                            selected={
                              item.to !== "" && item.to !== null ? new Date(item.to) : ""
                            }
                            onChange={this.handleChangeSpecificDate.bind(
                              this,
                              index,
                              "totime"
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-floating form-floating-outline mb-4 mt-2">
                          <input
                            type="text"
                            className="form-control"
                            value={item.orderCount}
                            id={"specific_count" + index}
                            onChange={this.handleChangeSpecificText.bind(
                              this,
                              index,
                              "orderCount"
                            )}
                          />
                          <label htmlFor={"specific_count" + index}>
                            Order Count
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          <div className="col-md-12 text-end mb-3">
            <a href="/" onClick={this.addSpecificDate.bind(this)}>
              <button
                type="button"
                className="btn btn-outline-primary waves-effect"
              >
                Add New
              </button>
            </a>
          </div> */}

          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box mb-4">
              <Select
                value={fields.slotStatus}
                onChange={this.handleSelectChange.bind(this, "slotStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>

          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
